/**
 * @generated SignedSource<<a206d4d034d000cb95abe3c0fdf9cc3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "documentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isInteractive"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLateEdit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isModelPreview"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isVariablesHighlighted"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orientation"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "padding"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pages"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "renderingEngineVersion"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "variables"
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documentId",
        "variableName": "documentId"
      },
      {
        "kind": "Variable",
        "name": "isInteractive",
        "variableName": "isInteractive"
      },
      {
        "kind": "Variable",
        "name": "isLateEdit",
        "variableName": "isLateEdit"
      },
      {
        "kind": "Variable",
        "name": "isModelPreview",
        "variableName": "isModelPreview"
      },
      {
        "kind": "Variable",
        "name": "isVariablesHighlighted",
        "variableName": "isVariablesHighlighted"
      },
      {
        "kind": "Variable",
        "name": "orientation",
        "variableName": "orientation"
      },
      {
        "kind": "Variable",
        "name": "padding",
        "variableName": "padding"
      },
      {
        "kind": "Variable",
        "name": "pages",
        "variableName": "pages"
      },
      {
        "kind": "Variable",
        "name": "renderingEngineVersion",
        "variableName": "renderingEngineVersion"
      },
      {
        "kind": "Variable",
        "name": "teamId",
        "variableName": "teamId"
      },
      {
        "kind": "Variable",
        "name": "variables",
        "variableName": "variables"
      }
    ],
    "concreteType": "HtmlMutationResponse",
    "kind": "LinkedField",
    "name": "previewDocumentHTML",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pagesHtml",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PreviewDocumentHtmlMutation",
    "selections": (v11/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v10/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PreviewDocumentHtmlMutation",
    "selections": (v11/*: any*/)
  },
  "params": {
    "cacheID": "0120e1f40babfe406590e4ba94dd126e",
    "id": null,
    "metadata": {},
    "name": "PreviewDocumentHtmlMutation",
    "operationKind": "mutation",
    "text": "mutation PreviewDocumentHtmlMutation(\n  $pages: [DocumentSectionInput!]\n  $variables: String\n  $documentId: ID\n  $padding: PaddingInput\n  $orientation: OrientationEnum!\n  $renderingEngineVersion: String\n  $isVariablesHighlighted: Boolean\n  $teamId: ID\n  $isModelPreview: Boolean\n  $isLateEdit: Boolean\n  $isInteractive: Boolean\n) {\n  previewDocumentHTML(pages: $pages, variables: $variables, documentId: $documentId, padding: $padding, orientation: $orientation, renderingEngineVersion: $renderingEngineVersion, isVariablesHighlighted: $isVariablesHighlighted, teamId: $teamId, isModelPreview: $isModelPreview, isLateEdit: $isLateEdit, isInteractive: $isInteractive) {\n    ok\n    error\n    pagesHtml\n  }\n}\n"
  }
};
})();

node.hash = "54880203609249ef793e4bfec9c8a8d4";

export default node;
